import React from 'react'
import SignaturePad from 'react-signature-canvas'

function SignatureInput({
    name,
    label,
    required,
    signatureDataURL,
    signatureRef,
    handleSave,
    handleClear,
    error,
    descriptionText,
    hidden,
    infoText,
}) {
    return (
        <div className='flex flex-col space-y-2'>
            <label
                for={name}
                className='font-semibold flex text-sm md:text-base lg:text-lg'
            >
                <p>{label}</p>
                {required && (
                    <span className='text-red-500'>*</span>
                )}
            </label>
            {descriptionText && (
                <p className='text-xs sm:text-sm xl:text-base'>{descriptionText}</p>
            )}
            {error && (
                <p className='text-xs sm:text-sm xl:text-base text-red-500'>{error}</p>
            )}
            {hidden ? (
                <div className="flex flex-col gap-4 items-center justify-center">
                    <img className=" bg-white h-full lg:h-96 w-full border-2 aspect-video rounded-md object-contain" src={signatureDataURL} />
                </div>
            ) : (
                <div className="flex flex-col gap-4 items-center justify-center">
                    <SignaturePad canvasProps={{ className: " bg-white h-full lg:h-96 w-full border-2 aspect-video rounded-md" }} ref={signatureRef} onEnd={handleSave} />
                    <button className="bg-white w-full px-3 sm:px-4 py-2 border-2 border-black rounded-md uppercase font-semibold text-xs sm:text-sm xl:text-base tracking-widest" onClick={handleClear}>
                        Clear Signature
                    </button>
                </div>
            )}
            <p className='text-xs md:text-sm text-app-grey'>{infoText}</p>
        </div>
    )
}

export default SignatureInput